import { __module as f } from "./ghl-ui.es1711.js";
(function(h, u) {
  Object.defineProperty(u, "__esModule", {
    value: !0
  }), u.default = o;
  function o(t) {
    return function(n) {
      var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = e.width, p = a && t.matchPatterns[a] || t.matchPatterns[t.defaultMatchWidth], c = n.match(p);
      if (!c)
        return null;
      var l = c[0], i = a && t.parsePatterns[a] || t.parsePatterns[t.defaultParseWidth], v = Array.isArray(i) ? m(i, function(d) {
        return d.test(l);
      }) : s(i, function(d) {
        return d.test(l);
      }), r;
      r = t.valueCallback ? t.valueCallback(v) : v, r = e.valueCallback ? e.valueCallback(r) : r;
      var P = n.slice(l.length);
      return {
        value: r,
        rest: P
      };
    };
  }
  function s(t, n) {
    for (var e in t)
      if (t.hasOwnProperty(e) && n(t[e]))
        return e;
  }
  function m(t, n) {
    for (var e = 0; e < t.length; e++)
      if (n(t[e]))
        return e;
  }
  h.exports = u.default;
})(f, f.exports);
var M = f.exports;
export {
  M as b
};
